export interface InventoryItem {
  id: string;
  itemCode: string;
  itemName: string;
  category: string;
  store: string;
  unit: string;
  currentQty: number;
  minStock: number;
  reorderLevel: number;
  maxStock: number;
  unitCost: number;
  avgCost: number;
  totalValue: number;
  supplier: string;
  batchNumber: string;
  expiryDate: string | null;
  stockStatus: 'in-stock' | 'low' | 'critical' | 'out-of-stock';
  daysRemaining: number | null;
  lastMovement: string;
  lastMovementType: string;
}

export interface StockMovement {
  id: string;
  date: string;
  reference: string;
  type: 'GRN' | 'GIN' | 'Transfer' | 'Adjustment' | 'Return' | 'Opening';
  itemCode: string;
  itemName: string;
  store: string;
  qty: number;
  direction: 'in' | 'out';
  unitCost: number;
  totalValue: number;
  balanceAfter: number;
  raisedBy: string;
  notes: string;
}

// Backend: GET /api/inventory
export const MOCK_INVENTORY: InventoryItem[] = [
  {
    id: 'inv-001', itemCode: 'FD-001', itemName: 'Broiler Starter Feed (Chick Mash)', category: 'Feed',
    store: 'Feed Store A', unit: 'kg', currentQty: 840, minStock: 1000, reorderLevel: 2000, maxStock: 10000,
    unitCost: 1850, avgCost: 1872, totalValue: 1572480,
    supplier: 'Ugachick Feeds Ltd', batchNumber: 'BS-2026-0841', expiryDate: '30/11/2026',
    stockStatus: 'critical', daysRemaining: 3.1, lastMovement: '03/09/2026', lastMovementType: 'GIN',
  },
  {
    id: 'inv-002', itemCode: 'FD-002', itemName: 'Broiler Grower Feed', category: 'Feed',
    store: 'Feed Store A', unit: 'kg', currentQty: 3240, minStock: 2000, reorderLevel: 3000, maxStock: 15000,
    unitCost: 1780, avgCost: 1795, totalValue: 5814600,
    supplier: 'Ugachick Feeds Ltd', batchNumber: 'BG-2026-0732', expiryDate: '15/12/2026',
    stockStatus: 'in-stock', daysRemaining: 12.4, lastMovement: '03/09/2026', lastMovementType: 'GIN',
  },
  {
    id: 'inv-003', itemCode: 'FD-003', itemName: 'Broiler Finisher Feed', category: 'Feed',
    store: 'Feed Store A', unit: 'kg', currentQty: 5600, minStock: 2000, reorderLevel: 3000, maxStock: 15000,
    unitCost: 1720, avgCost: 1735, totalValue: 9716000,
    supplier: 'Ugachick Feeds Ltd', batchNumber: 'BF-2026-0621', expiryDate: '20/12/2026',
    stockStatus: 'in-stock', daysRemaining: 21.5, lastMovement: '02/09/2026', lastMovementType: 'GRN',
  },
  {
    id: 'inv-004', itemCode: 'FD-004', itemName: 'Layers Mash (16% CP)', category: 'Feed',
    store: 'Feed Store B', unit: 'kg', currentQty: 1840, minStock: 1500, reorderLevel: 3000, maxStock: 12000,
    unitCost: 1680, avgCost: 1692, totalValue: 3113280,
    supplier: 'Kenchic Feeds Uganda', batchNumber: 'LM-2026-0512', expiryDate: '10/01/2027',
    stockStatus: 'low', daysRemaining: 4.6, lastMovement: '03/09/2026', lastMovementType: 'GIN',
  },
  {
    id: 'inv-005', itemCode: 'FD-005', itemName: 'Layer Chick Mash', category: 'Feed',
    store: 'Feed Store B', unit: 'kg', currentQty: 2200, minStock: 800, reorderLevel: 1500, maxStock: 8000,
    unitCost: 1720, avgCost: 1728, totalValue: 3801600,
    supplier: 'Kenchic Feeds Uganda', batchNumber: 'LC-2026-0401', expiryDate: '05/01/2027',
    stockStatus: 'in-stock', daysRemaining: 18.3, lastMovement: '01/09/2026', lastMovementType: 'GRN',
  },
  {
    id: 'inv-006', itemCode: 'FD-006', itemName: 'Breeder Feed (Pre-Layer)', category: 'Feed',
    store: 'Feed Store B', unit: 'kg', currentQty: 980, minStock: 500, reorderLevel: 1000, maxStock: 5000,
    unitCost: 1950, avgCost: 1962, totalValue: 1922760,
    supplier: 'Ugachick Feeds Ltd', batchNumber: 'BRD-2026-0311', expiryDate: '28/12/2026',
    stockStatus: 'low', daysRemaining: 7.2, lastMovement: '02/09/2026', lastMovementType: 'GIN',
  },
  {
    id: 'inv-007', itemCode: 'VAC-001', itemName: 'Newcastle Disease Vaccine (La Sota)', category: 'Vaccine',
    store: 'Cold Store', unit: 'doses×1000', currentQty: 12, minStock: 10, reorderLevel: 20, maxStock: 100,
    unitCost: 45000, avgCost: 46200, totalValue: 554400,
    supplier: 'Bayer Animal Health', batchNumber: 'VAC-ND-2026-041', expiryDate: '31/12/2026',
    stockStatus: 'critical', daysRemaining: null, lastMovement: '28/08/2026', lastMovementType: 'GRN',
  },
  {
    id: 'inv-008', itemCode: 'VAC-002', itemName: 'Gumboro (IBD) Vaccine', category: 'Vaccine',
    store: 'Cold Store', unit: 'doses×1000', currentQty: 28, minStock: 10, reorderLevel: 20, maxStock: 80,
    unitCost: 52000, avgCost: 53100, totalValue: 1486800,
    supplier: 'Bayer Animal Health', batchNumber: 'VAC-IBD-2026-038', expiryDate: '28/02/2027',
    stockStatus: 'in-stock', daysRemaining: null, lastMovement: '25/08/2026', lastMovementType: 'GRN',
  },
  {
    id: 'inv-009', itemCode: 'VAC-003', itemName: 'Marek\'s Disease Vaccine', category: 'Vaccine',
    store: 'Cold Store', unit: 'doses×1000', currentQty: 8, minStock: 5, reorderLevel: 10, maxStock: 50,
    unitCost: 68000, avgCost: 68000, totalValue: 544000,
    supplier: 'MSD Animal Health', batchNumber: 'VAC-MD-2026-019', expiryDate: '30/09/2026',
    stockStatus: 'low', daysRemaining: null, lastMovement: '20/08/2026', lastMovementType: 'GRN',
  },
  {
    id: 'inv-010', itemCode: 'MED-001', itemName: 'Enrofloxacin 10% Solution', category: 'Medication',
    store: 'Pharmacy Store', unit: 'bottles (1L)', currentQty: 3, minStock: 5, reorderLevel: 10, maxStock: 30,
    unitCost: 85000, avgCost: 87200, totalValue: 261600,
    supplier: 'Elanco Uganda', batchNumber: 'ENR-2026-0512', expiryDate: '31/03/2027',
    stockStatus: 'low', daysRemaining: null, lastMovement: '03/09/2026', lastMovementType: 'GIN',
  },
  {
    id: 'inv-011', itemCode: 'MED-002', itemName: 'Vitamin C + Electrolytes Powder', category: 'Medication',
    store: 'Pharmacy Store', unit: 'kg', currentQty: 8.5, minStock: 3, reorderLevel: 5, maxStock: 20,
    unitCost: 42000, avgCost: 42000, totalValue: 357000,
    supplier: 'Elanco Uganda', batchNumber: 'VIT-2026-0418', expiryDate: '15/06/2027',
    stockStatus: 'in-stock', daysRemaining: null, lastMovement: '01/09/2026', lastMovementType: 'GIN',
  },
  {
    id: 'inv-012', itemCode: 'MED-003', itemName: 'Oxytetracycline HCl 20%', category: 'Medication',
    store: 'Pharmacy Store', unit: 'bottles (1L)', currentQty: 6, minStock: 4, reorderLevel: 8, maxStock: 25,
    unitCost: 72000, avgCost: 73500, totalValue: 441000,
    supplier: 'Bayer Animal Health', batchNumber: 'OTC-2026-0332', expiryDate: '30/04/2027',
    stockStatus: 'in-stock', daysRemaining: null, lastMovement: '30/08/2026', lastMovementType: 'GRN',
  },
  {
    id: 'inv-013', itemCode: 'PKG-001', itemName: 'Egg Trays (30-cell Pulp)', category: 'Packaging',
    store: 'Packaging Store', unit: 'trays', currentQty: 240, minStock: 200, reorderLevel: 500, maxStock: 3000,
    unitCost: 1200, avgCost: 1200, totalValue: 288000,
    supplier: 'Nile Pack Ltd', batchNumber: '—', expiryDate: null,
    stockStatus: 'low', daysRemaining: null, lastMovement: '02/09/2026', lastMovementType: 'GIN',
  },
  {
    id: 'inv-014', itemCode: 'CHM-001', itemName: 'Virkon S Disinfectant (1kg)', category: 'Chemicals',
    store: 'Biosecurity Store', unit: 'sachets', currentQty: 48, minStock: 20, reorderLevel: 30, maxStock: 200,
    unitCost: 18000, avgCost: 18400, totalValue: 883200,
    supplier: 'Vetoquinol Uganda', batchNumber: 'VKS-2026-0621', expiryDate: '31/12/2027',
    stockStatus: 'in-stock', daysRemaining: null, lastMovement: '25/08/2026', lastMovementType: 'GRN',
  },
  {
    id: 'inv-015', itemCode: 'PPE-001', itemName: 'Protective Overalls (Disposable)', category: 'PPE',
    store: 'Biosecurity Store', unit: 'pieces', currentQty: 0, minStock: 20, reorderLevel: 50, maxStock: 200,
    unitCost: 8500, avgCost: 8500, totalValue: 0,
    supplier: 'SafeGuard Uganda', batchNumber: '—', expiryDate: null,
    stockStatus: 'out-of-stock', daysRemaining: null, lastMovement: '15/08/2026', lastMovementType: 'GIN',
  },
];

// Backend: GET /api/inventory/movements
export const MOCK_MOVEMENTS: StockMovement[] = [
  { id: 'mov-001', date: '03/09/2026', reference: 'GIN-2026-0341', type: 'GIN', itemCode: 'FD-001', itemName: 'Broiler Starter Feed', store: 'Feed Store A', qty: 420, direction: 'out', unitCost: 1872, totalValue: 786240, balanceAfter: 840, raisedBy: 'Ogenga Paul', notes: 'Daily feed issue — House A2 Flock BR-2026-002' },
  { id: 'mov-002', date: '03/09/2026', reference: 'GIN-2026-0340', type: 'GIN', itemCode: 'MED-001', itemName: 'Enrofloxacin 10%', store: 'Pharmacy Store', qty: 2, direction: 'out', unitCost: 87200, totalValue: 174400, balanceAfter: 3, raisedBy: 'Dr. Nakato Sarah', notes: 'Treatment — respiratory infection BR-2026-002' },
  { id: 'mov-003', date: '02/09/2026', reference: 'GRN-2026-0181', type: 'GRN', itemCode: 'FD-003', itemName: 'Broiler Finisher Feed', store: 'Feed Store A', qty: 3000, direction: 'in', unitCost: 1720, totalValue: 5160000, balanceAfter: 5600, raisedBy: 'Akello Grace', notes: 'Delivery from Ugachick Feeds — PO-2026-038' },
  { id: 'mov-004', date: '02/09/2026', reference: 'GIN-2026-0339', type: 'GIN', itemCode: 'FD-004', itemName: 'Layers Mash', store: 'Feed Store B', qty: 380, direction: 'out', unitCost: 1692, totalValue: 642960, balanceAfter: 1840, raisedBy: 'Apio Christine', notes: 'Daily feed issue — Layer House 01 & 02' },
  { id: 'mov-005', date: '01/09/2026', reference: 'GRN-2026-0180', type: 'GRN', itemCode: 'FD-005', itemName: 'Layer Chick Mash', store: 'Feed Store B', qty: 2000, direction: 'in', unitCost: 1720, totalValue: 3440000, balanceAfter: 2200, raisedBy: 'Akello Grace', notes: 'Delivery from Kenchic Feeds — PO-2026-037' },
  { id: 'mov-006', date: '01/09/2026', reference: 'ADJ-2026-009', type: 'Adjustment', itemCode: 'FD-004', itemName: 'Layers Mash', store: 'Feed Store B', qty: 80, direction: 'out', unitCost: 1692, totalValue: 135360, balanceAfter: 1920, raisedBy: 'Akello Grace', notes: 'Stock count variance — pending manager approval' },
  { id: 'mov-007', date: '31/08/2026', reference: 'GIN-2026-0335', type: 'GIN', itemCode: 'FD-001', itemName: 'Broiler Starter Feed', store: 'Feed Store A', qty: 420, direction: 'out', unitCost: 1872, totalValue: 786240, balanceAfter: 1260, raisedBy: 'Ogenga Paul', notes: 'Daily feed issue — House A2' },
  { id: 'mov-008', date: '30/08/2026', reference: 'GRN-2026-0178', type: 'GRN', itemCode: 'VAC-001', itemName: 'Newcastle Vaccine', store: 'Cold Store', qty: 20, direction: 'in', unitCost: 45000, totalValue: 900000, balanceAfter: 32, raisedBy: 'Dr. Nakato Sarah', notes: 'Vaccine order — cold chain verified on receipt' },
];

export const CATEGORY_SUMMARIES = [
  { id: 'cat-feed', category: 'Feed', itemCount: 6, totalValue: 25940720, criticalCount: 1, lowCount: 2, icon: 'Wheat', color: 'var(--accent)' },
  { id: 'cat-vaccine', category: 'Vaccines', itemCount: 3, totalValue: 2585200, criticalCount: 1, lowCount: 1, icon: 'Syringe', color: 'var(--info)' },
  { id: 'cat-medication', category: 'Medication', itemCount: 3, totalValue: 1059600, criticalCount: 0, lowCount: 1, icon: 'Pill', color: 'var(--warning)' },
  { id: 'cat-other', category: 'Other Supplies', itemCount: 3, totalValue: 1171200, criticalCount: 1, lowCount: 1, icon: 'Package', color: '#8b5cf6' },
];